/* eslint-disable */
import Hashtags from "components/Hashtags";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import CareerInfo from "../CareerInfo";
import CareerInfoContent from "../CareerInfoContent";
import JobFields from "../JobFields";
import SalleryDistribution from "../SalleryDistribution";
import Comments from "../Comments";
import styles from "./index.module.scss";
import HighlightningBenefits from "../HiglightningBenefits";
import Stats from "../Stats";
import GeneralSkills from "../GeneralSkills";
import TechnicalSkills from "../TechnicalSkills";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import SuggestionsBlock from "components/SuggestionsBlock";
import ReadMore from "components/ReadMore";
import ReactPlayer from "react-player";
import { ApplyBlock } from "components/ApplyNow/ApplyBlock";
import { t } from "i18next";
import { addSinglePersonalAISuccess } from "store/slices/personalai";
import { useDispatch } from "react-redux";
import { useAddPersonalAI } from "hooks/personalai";
import { useNavigate } from "react-router-dom";
import applyBackground from "assets/images/apply-background.png";
import Poadcast from "../Poadcast";
import ReportProblem from "pages/Block/ReportProblem";

const OverviewDesktop = () => {
  const {
    lifeChoice: {
      hashtags,
      description,
      video,
      _id,
      title,
      profile_images,
      is_major,
      youtube_podcast,
    },
  } = useLifeChoicePageContext();
  const { dir, language } = useAppSelector(getSettings);
  const dispatch = useDispatch();
  const { mutate: addPersonalAI } = useAddPersonalAI(language);
  const navigate = useNavigate();

  const isThisTheRightPathForMe = () => {
    const id = new Date().getTime();
    dispatch(
      addSinglePersonalAISuccess({
        major: {
          title,
          profile_images: profile_images.map((image) => image.split("/").pop()),
          is_major,
        },
        id,
        createdAt: new Date().toISOString(),
      })
    );
    addPersonalAI({ id: _id, tempID: id });
    navigate("/personal-ai?tab=recommendations");
  };

  if (!dir || !language) return null;

  return (
    <div className={`${styles["overview-desktop-wrapper"]} container`}>
      <div className={"flex flex-col lg:flex-row lg:gap-10"}>
        <div className={"w-full lg:w-[60%]"}>
          {hashtags ? (
            <Hashtags
              hashtags={hashtags}
              className={styles["hashtags-overview"]}
            />
          ) : (
            ""
          )}
          <p className="px-4 font-heebo mt-8">
            <ReadMore
              charactersToPreview={290}
              dir={dir}
              lang={language}
              readMoreColor="text-theme-purple"
            >
              {description[language]}
            </ReadMore>
          </p>
          {video ? (
            <div className="w-full my-5">
              <ReactPlayer url={video} className="!w-full" />
            </div>
          ) : (
            ""
          )}

          <div
            className="relative flex justify-center mt-5 lg:hidden bg-center bg-cover bg-no-repeat rounded-2xl"
            style={{ backgroundImage: `url(${applyBackground})` }}
          >
            {/* <div
              className="triangle rotate-180 absolute -top-[1px]"
              style={{
                borderWidth: "0 1rem 1rem 1rem",
                borderColor: "transparent transparent white transparent",
              }}
            /> */}
            <ApplyBlock
              buttonText={t("isThisTheRightPathForMeButton")}
              onClick={isThisTheRightPathForMe}
              containerClass="mx-0 w-full px-4  pt-[36px] pb-[48px]"
              text={t("consultWithAI")}
              buttonClass="bg-gradient-to-b from-[#F29423] to-[#B46C16] text-white"
            />
          </div>
          <div className="lg:hidden block mt-10">
            <HighlightningBenefits />
          </div>
          <div className="lg:hidden block mt-10">
            <Stats />
          </div>
          <div className="mt-6">
            <Comments className={"pb-0 custom-comment-pagination"} />
          </div>
          {youtube_podcast ? <div className="mt-6">
            <Poadcast poadcast={youtube_podcast} />
          </div> : ''}
          <div className="lg:hidden block">
            <GeneralSkills />
          </div>
          <div className="lg:hidden block mt-8">
            <TechnicalSkills />
          </div>
          <CareerInfo>
            <CareerInfoContent />
            <JobFields />
            <SalleryDistribution />
          </CareerInfo>
        </div>
        <div className={"w-full lg:w-[40%] flex flex-col gap-8 items-center"}>
          <div className="hidden lg:contents">
            <HighlightningBenefits />
          </div>
          <div className="hidden lg:contents">
            <Stats />
          </div>
          {/* <div className="hidden lg:contents">
            <AIButton className="w-full" />
          </div> */}
          <div
            className="relative justify-center mt-5 hidden w-full lg:flex  bg-center bg-cover bg-no-repeat rounded-2xl"
            style={{ backgroundImage: `url(${applyBackground})` }}
          >
            {/* <div
              className="triangle rotate-180 absolute -top-[1px]"
              style={{
                borderWidth: "0 1rem 1rem 1rem",
                borderColor: "transparent transparent white transparent",
              }}
            /> */}
            <ApplyBlock
              buttonText={t("isThisTheRightPathForMeButton")}
              onClick={isThisTheRightPathForMe}
              text={t("consultWithAI")}
              containerClass="mx-0 w-full px-4 pt-[36px] pb-[48px]"
              buttonClass="bg-gradient-to-b from-[#F29423] to-[#B46C16] text-white"
            />
          </div>
          <div className="hidden lg:contents">
            <GeneralSkills />
          </div>
          <div className="hidden lg:contents">
            <TechnicalSkills />
          </div>
        </div>
      </div>
      <ReportProblem className="-mt-6 -mb-10" />
      <SuggestionsBlock />
    </div>
  );
};

export default OverviewDesktop;
